import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { selectBrand, selectContent, useAppSelector } from '@open-tender/cloud'
import {
  Content,
  DonationForm,
  FormWrapper,
  Main,
  PageTitle,
  HeaderDefault,
  PageContainer,
} from 'components'

const Donations = () => {
  const navigate = useNavigate()
  const { donations: config } = useAppSelector(selectContent) || {}
  const { title: siteTitle, has_donations } = useAppSelector(selectBrand) || {}

  useEffect(() => {
    if (!has_donations) return navigate('/account')
  }, [has_donations, navigate])

  return (
    <>
      <Helmet>
        <title>
          {config?.title} | {siteTitle}
        </title>
      </Helmet>
      <Content>
        <HeaderDefault />
        <Main>
          <PageContainer style={{ maxWidth: '76.8rem' }}>
            <PageTitle {...config} />
            <FormWrapper>
              <DonationForm />
            </FormWrapper>
          </PageContainer>
        </Main>
      </Content>
    </>
  )
}

export default Donations
